import { goBack } from "connected-react-router";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { isEmpty } from "lodash";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { actions as contactActions } from "reducers/contactDestination";
import * as i18n from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import ContactSummaryBody from "./_components/ContactSummary";

const NewContactSummaryPage = () => {
    const { frequentDestination } = useSelector((state) => state.contactDestination);
    const { contactTicket } = useSelector((state) => state.contactDestination);
    const { dispatch } = useConfirmTransaction(frequentDestination, contactTicket, "contactDestination");
    useEffect(() => {
        if (isEmpty(frequentDestination)) {
            dispatch(goBack());
        }
    }, []);

    return (
        <>
            <Notification scopeToShow="frequentDestinationCreateConfirm" />
            <ResponsiveHeader id="transfer.contactDestination.title" />
            <MainContainer showLoader={false}>
                <h3><CustomText text={i18n.get("frequentDestination.modify.subtitle")} /></h3> 
                <ContactSummaryBody
                    accountNumber={frequentDestination.accountNumber}
                    productType={frequentDestination?.productType}
                    cbu={frequentDestination.cbu}
                    name={frequentDestination.name}
                    localBank={frequentDestination.localBank}
                    recipientEmail={frequentDestination.recipientEmail}
                    recipientDocumentType={frequentDestination.recipientDocumentType}
                    recipientDocumentNumber={frequentDestination.recipientDocumentNumber}
                    recipientName={frequentDestination.recipientName}
                    isOwn={frequentDestination.isOwn}
                />
                <GeneralCredentialForm
                    transactionData={frequentDestination}
                    action={contactActions.frequentDestinationCreateRequest}
                    idActivity="destinations.create"
                />
            </MainContainer>
        </>
    );
};

export default NewContactSummaryPage;
